export default __webpack_public_path__ + "static/media/white-right-errow.fad77f9c.svg";